<template>
    <div class="menu-watefall">
        <div class="work-plant">
             <i class="iconfont icon-other-gongzuotai1"></i>
             <div class="work-plant-menu">
                <div class="menu-content">
                    <div class="menu-item" v-for="(item,index) in menuData" :key="index" v-if="!item.hidenMenuWaterfall">
                        <div class="menu-item-parent">
                             {{item.meta.title}}
                        </div>
                        <div class="menu-item-child" v-for="(obj,ind) in item.children" :key="ind" @click="jumpUrl(obj)" v-if="obj.isMenuWaterfall == true">
                            <i :class="obj.meta.icon" :style="'color:'+obj.meta.color+';'"></i>{{obj.meta.title}}
                        </div>
                    </div>
                </div>
             </div>
        </div>

    </div>
</template>

<script>
    import * as constants from '@/common/constants';
    import { cloneDeep } from 'lodash';
    import { mapActions, mapGetters } from 'vuex';
    import mixinsNav from '@/mixins/mixins-nav';
    export default{
        mixins: [mixinsNav],
        computed: {
            ...mapGetters([
                'routers'
            ])
        },
        props: {
            resource: {
                type: String
            }
        },
        data () {
            return {
                menuData: []
            };
        },
        watch: {
            routers (val) {
                if (val.length > 0) {
                    this.menuData = [];
                    this.menuData = cloneDeep(val);
                    this.addOtherMenu();
                }
            }
        },
        created () {
            this[constants.VUEX_ACTIONS_ROUTER_GET_ALL]();// 缓存菜单
            if (this.routers.length > 0) {
                this.menuData = [];
                this.menuData = cloneDeep(this.routers);
                this.addOtherMenu();
            }
        },
        methods: {
            ...mapActions([
                constants.VUEX_ACTIONS_ROUTER_GET_ALL
            ]),
            jumpUrl (val) {
                let url = '/' + val.id;
                let name = val.name;
                // sessionStorage.setItem('currentOpenUrl', url);// 路由定位
                this.navigateNameTo(url, name);
            },
            addOtherMenu () {
                if (this.resource === '1') { // 应用中心
                    let obj = {
                        redirect: 'noredirect',
                        name: 'business',
                        isMenuWaterfall: true,
                        meta: {
                            title: '应用中心',
                            icon: 'el-icon-cpu'
                        },
                        children: [
                            {
                                path: 'businessSystem',
                                name: 'businessSystem',
                                id: 'businessSystem',
                                meta: {
                                    title: '应用中心',
                                    icon: 'iconfont icon-other-yingyongzhongxin',
                                    color: '#d81e06'
                                },
                                isShow: false,
                                isNewMenu: true,
                                isMenuWaterfall: true
                            }
                        ]
                    };
                    this.menuData.push(obj);
                } else if (this.resource === '2') { // 仪表盘
                    let obj = {
                        redirect: 'noredirect',
                        name: 'business',
                        isMenuWaterfall: true,
                        meta: {
                            title: '仪表盘',
                            icon: 'el-icon-cpu'
                        },
                        children: [
                            {
                                path: 'dashBoradCenter',
                                name: 'dashBoradCenter',
                                id: 'dashBoradCenter',
                                meta: {
                                    title: '仪表盘',
                                    icon: 'iconfont icon-other-yibiao',
                                    color: '#1296db'
                                },
                                isShow: false,
                                isNewMenu: true,
                                isMenuWaterfall: true
                            }
                        ]
                    };
                    this.menuData.push(obj);
                }
            }
        }
    };
</script>

<style lang="less">
    .menu-watefall{
        .work-plant{
            position: relative;
            width: 60px;
            height: 60px;
            cursor: pointer;
            .icon-other-gongzuotai1{
                font-size: 30px;
                font-weight: 600;
                color:#1296db;
                cursor: pointer;
                margin-top: 18px;
                margin-left: 10px;
            }
            .work-plant-menu{
                display: none;
                background-color: #FFFFFF;
                position: absolute;
                z-index: 100;
                top: 50px;
                left: 10px;
                width: auto;
                height: auto;
                min-height: 300px;
                border: 1px solid #d9d5db;
                .menu-content{
                    display: flex;
                    width: auto;
                    height: auto;
                    min-height: 300px;
                    max-height: 94vh;
                    overflow: auto;
                    .menu-item{
                        width:180px;
                        height: auto;
                        min-height: 300px;
                        .menu-item-parent{
                            font-size: 20px;
                            font-weight: 700;
                        }
                        .menu-item-child{
                            font-size: 16px;
                            font-weight: 400;
                            text-align: left;
                            height: 36px;
                            line-height: 36px;
                            margin-left: 38px;
                        }
                    }
                }
            }
        }
        .work-plant:hover{
            .work-plant-menu{
                display: block;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/MenuWaterfall/MenuWaterfall.vue